import { useEffect, useState } from "react";
import { getOnchainConsentInfo, IOnchainConsentInfo } from "../network";

type RequestState = {
  requestId: string;
  info: IOnchainConsentInfo | null;
  isLoading: boolean;
  error: Error | null;
};

export const useOnchainConsentInfo = (
  verificationRequestId?: string,
): [IOnchainConsentInfo | null, boolean, Error | null] => {
  const [state, setState] = useState<RequestState | null>(null);

  useEffect(() => {
    if (!verificationRequestId) {
      setState(null);
      return;
    }

    let active = true;
    setState({
      requestId: verificationRequestId,
      info: null,
      isLoading: true,
      error: null,
    });

    const load = async () => {
      try {
        const info = await getOnchainConsentInfo(verificationRequestId);
        if (active) {
          setState({ requestId: verificationRequestId, info, isLoading: false, error: null });
        }
      } catch (cause) {
        if (active) {
          const error = cause instanceof Error ? cause : new Error("Unknown error");
          setState({ requestId: verificationRequestId, info: null, isLoading: false, error });
        }
      }
    };

    load();
    return () => {
      active = false;
    };
  }, [verificationRequestId]);

  if (!verificationRequestId || state?.requestId !== verificationRequestId) {
    return [null, Boolean(verificationRequestId), null];
  }

  return [state.info, state.isLoading, state.error];
};
